import Vue from 'vue'
import Vuex from 'vuex'
import Moment from 'vue-moment'
import Toasted from 'vue-toasted'
import VueCookies from 'vue-cookies'
import Router from './router'
import App from './App.vue'
import Store from './store/index.js'
import DownloadExcel from './components/shared/DownloadExcel.vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { Swatches } from 'vue-color'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './styles/logs.css'

Vue.use(Vuex)
Vue.use(Moment)
Vue.use(Toasted, {
  position: 'top-center',
  fitToScreen: true,
  keepOnHover: true,
  type: 'info'
})
Vue.use(VueCookies)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Element, { locale })
Vue.component('downloadExcel', DownloadExcel)
Vue.component('colorPicker', Swatches)

Vue.$cookies.config('8h')

Vue.config.productionTip = false

new Vue({
  router: Router,
  store: Store(Vuex),
  render: (h) => h(App)
}).$mount('#app')
